import React, { ReactElement, ChangeEvent } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Select from 'components/@common/Inputs/Select';

export interface DropDownOptions {
  label: string | ReactElement;
  value: any;
}

type DropdownProps = {
  options: Array<DropDownOptions>;
  value: string | number;
  label: string | ReactElement;
  placeholder?: string;
  id: string;
  handleChange: (event: ChangeEvent<any>) => void;
};

const Dropdown: React.FC<DropdownProps> = ({
  id,
  label,
  placeholder,
  handleChange,
  value,
  options,
  ...selectProps
}) => {
  return (
    <Select
      label={label}
      placeholder={placeholder ?? `${label}`}
      id={`${id}-select`}
      value={value}
      onChange={handleChange}
      {...selectProps}
    >
      {options.map(
        (option: any, key: any): ReactElement => (
          <MenuItem key={`${key}-dropdown-${id}-item`} value={option.value}>
            {option.label}
          </MenuItem>
        )
      )}
    </Select>
  );
};

export default Dropdown;
